import { checkStatus, request, requestConfig } from '../../../../utils/request.js';

import {
    FETCH_USER, FETCH_USER_SUCCESS, FETCH_USER_FAILURE,
    FETCH_USERS, FETCH_USERS_SUCCESS, FETCH_USERS_FAILURE,
    FETCH_ASSIGNMENTS_FOR_USER, FETCH_ASSIGNMENTS_FOR_USER_SUCCESS, FETCH_ASSIGNMENTS_FOR_USER_FAILURE,
    REMOVE_USER, REMOVE_USER_SUCCESS, REMOVE_USER_FAILURE,
    SAVE_USER, SAVE_USER_SUCCESS, SAVE_USER_FAILURE,
    UPDATE_CSV_TO_UPLOAD, UPDATE_USERS, UPDATE_SEARCH_TERM, UPDATE_THUMBNAIL_TO_UPLOAD, SET_USER, CLEAR_USER, EMPTY_USERS,
    UPLOAD_IMPORT_USERS, UPLOAD_IMPORT_USERS_SUCCESS, UPLOAD_IMPORT_USERS_FAILURE
} from './constants';

import { PATHS } from 'utils/paths';
import { USER_ROLES } from 'utils/constants';

const fetchUser = () => ({
    type: FETCH_USER
});

const fetchUserSuccess = (data) => ({
    type: FETCH_USER_SUCCESS,
    data
});

const fetchUserFailure = (error) => ({
    type: FETCH_USER_FAILURE,
    error
});

const fetchUsers = () => ({
    type: FETCH_USERS
});

const fetchUsersSuccess = (data) => ({
    type: FETCH_USERS_SUCCESS,
    data
});

const fetchUsersFailure = (error) => ({
    type: FETCH_USERS_FAILURE,
    error
});

const fetchAssignmentsForUser = () => ({
    type: FETCH_ASSIGNMENTS_FOR_USER
});

const fetchAssignmentsForUserSuccess = () => ({
    type: FETCH_ASSIGNMENTS_FOR_USER_SUCCESS
});

const fetchAssignmentsForUserFailure = (error) => ({
    type: FETCH_ASSIGNMENTS_FOR_USER_FAILURE,
    error
});

export const updateUsers = (data) => ({
    type: UPDATE_USERS,
    data
});

export const updateSearchTerm = (data) => ({
    type: UPDATE_SEARCH_TERM,
    data
});

export const setUser = (data) => ({
    type: SET_USER,
    data
});

export const clearUser = () => ({
    type: CLEAR_USER
});

export const emptyUsers = () => ({
    type: EMPTY_USERS
});

const saveUser = () => ({
    type: SAVE_USER
});

const saveUserSuccess = (data) => ({
    type: SAVE_USER_SUCCESS,
    data
});

const saveUserFailure = (error) => ({
    type: SAVE_USER_FAILURE,
    error
});

const removeUser = () => ({
    type: REMOVE_USER
});

const removeUserSuccess = () => ({
    type: REMOVE_USER_SUCCESS
});

const removeUserFailure = (error) => ({
    type: REMOVE_USER_FAILURE,
    error
});

export const updateCSVToUpload = (data) => ({
    type: UPDATE_CSV_TO_UPLOAD,
    data
});

export const updateThumbnailToUpload = (data) => ({
    type: UPDATE_THUMBNAIL_TO_UPLOAD,
    data
});

const uploadImportUsers = (data) => ({
    type: UPLOAD_IMPORT_USERS,
    data
});

const uploadImportUsersSuccess = () => ({
    type: UPLOAD_IMPORT_USERS_SUCCESS
});

export const uploadImportUsersFailure = (error) => ({
    type: UPLOAD_IMPORT_USERS_FAILURE,
    error
});


/**
 *  ASYNC ACTIONS
 */
export const getUser = (user) => (dispatch) => {
    dispatch(fetchUser());

    return request(PATHS.users.getUser.byID(user.id), requestConfig('GET'))
        .then((fullUser) => {
            dispatch(fetchUserSuccess(fullUser));
            return fullUser;
        })
        .catch((error) => {
            console.log('error getting full user', error);
            dispatch(fetchUserFailure(error));
        });
};

export const getUsers = (callback) => (dispatch, getState) => {
    dispatch(fetchUsers());
    let usersStore = getState().users;
    let isCreatorAdmin = getState().auth.role === USER_ROLES.CREATOR_ADMIN;
    let path = '';
    let pageNumber = usersStore.pageNumber + 1;

    if(usersStore.searchTerm !== '') {
        path = PATHS.users.getUsers.search(usersStore.searchTerm, pageNumber, usersStore.pageSize, isCreatorAdmin);
    } else {
        let userId = getState().auth.user.id;
        path = PATHS.users.getUsers.filtered(usersStore.filterBy, usersStore.sortBy, usersStore.sortDirection, pageNumber, usersStore.pageSize, userId, isCreatorAdmin);
    }

    request(path, requestConfig('GET'))
        .then((data) => {
            dispatch(fetchUsersSuccess(data));
            if(callback) {
                callback();
            }
        })
        .catch((error) => {
            console.log(error);
            dispatch(fetchUsersFailure(error));
        });
};

export const getAssignmentsAndSetUser = (user) => (dispatch, getState) => {
    dispatch(setUser(user));

    dispatch(getUser(user))
        .then((fullUser) => {
            let assignmentIds = [];
            fullUser.assignmentIds.entry.forEach((set) => {
                set.ints = [];
                set.value.split(' ').forEach((val) => {
                    set.ints.push(parseInt(val, 10));
                    assignmentIds.push(parseInt(val, 10));
                })
            });

            if(assignmentIds.length > 0) {
                dispatch(fetchAssignmentsForUser());

                request(PATHS.assignments.getAssignmentMultiple(assignmentIds.join(',')), requestConfig('GET'))
                    .then((assignments) => {

                        fullUser.assignments = assignments;
                        dispatch(fetchAssignmentsForUserSuccess());

                        // Test to ensure user in the store is the same as the user in the response. If not, abort save
                        // This would happen if user closes modal and opens another before assignment query resolves.
                        if (getState().users.user.id === fullUser.id) {
                            dispatch(setUser(fullUser));
                        }
                    })
                    .catch((error) => {
                        console.log('error getting assignment', error);
                        dispatch(fetchAssignmentsForUserFailure(error));
                    });
            } else {
                // Test to ensure user in the store is the same as the user in the response. If not, abort save
                // This would happen if user closes modal and opens another before assignment query resolves.
                if (getState().users.user.id === fullUser.id) {
                    dispatch(setUser(fullUser));
                }
            }
        });
};

export const postPutUser = (callback) => (dispatch, getState) => {
    dispatch(saveUser());
    let user = getState().users.user;
    let method = 'POST';
    let path = PATHS.users.postUser();

    if(user.id != null) {
        method = 'PUT';
        path = PATHS.users.putUser(user.id);
    }

    if(user.department != null && Object.keys(user.department).length === 0) {
        delete user.department;
    }

    request(path, requestConfig(method, user))
        .then((newUser) => {
            if(newUser.assignmentIds == null && user.assignmentIds == null) {
                newUser.assignmentIds = [];
            } else {
                // So we don't need to re-request assignments for the user details modal
                newUser.assignmentIds = user.assignmentIds;
                newUser.assignments = user.assignments;
            }

            dispatch(saveUserSuccess(newUser));

            if(method === 'PUT' && getState().users.sortBy !== 'modified') { // I'm intentionally excluding modified here, because the user will go at the top, if they are not already
                // Loop through all existing users to see if this user exists. If so, replace it in the array
                let users = getState().users.allUsers;
                for(var i = 0, l = users.length; i < l; i++) {
                    if(users[i].id === newUser.id) {
                        users[i] = newUser;
                        break;
                    }
                }
            } else {
                //If it's a new user, then get all users again
                let users = getState().users;
                users.pageNumber = 0;
                users.hasMore = true;
                users.allUsers = [];
                dispatch(updateUsers(users));
                dispatch(getUsers());
            }

            if(callback) {
                callback();
            }
        })
        .catch((error) => {
            console.log(error);
            if(error.status === 204) {
                error.friendlyMessage = 'That email address is already in use. Please choose another.';
            } else {
                error.friendlyMessage = 'There was an error saving this user. Please try again.';
            }
            dispatch(saveUserFailure(error));
        });
};

export const deleteUser = (callback) => (dispatch, getState) => {
    dispatch(removeUser());
    let user = getState().users.user;
    request(PATHS.users.putUser(user.id), requestConfig('DELETE'))
        .then(() => {
            // Loop through all existing users to see if this user exists. If so, remove it
            let users = getState().users.allUsers;
            for(var i = 0, l = users.length; i < l; i++) {
                if(users[i].id === user.id) {
                    users.splice(i, 1);
                    break;
                }

            }
            dispatch(removeUserSuccess());
            if(callback) {
                callback();
            }
        })
        .catch((error) => {
            dispatch(removeUserFailure(error));
        })
};

export const postUserAvatar = (callback) => (dispatch, getState) => {
    dispatch(saveUser());

    let file = getState().users.thumbnailToUpload;

    let xhr = new XMLHttpRequest();
    let formData = new FormData();
    formData.append('file', file);

    xhr.open("POST", PATHS.upload.thumbnail(), true);
    xhr.withCredentials = true;
    xhr.setRequestHeader('Accept', 'application/json');

    // Get the thumbnail elements.
    // TODO: This will need to be boilerplated somehow
    let progressBarEl = document.getElementById('thumbnailProgress'),
        progressBarWrapperEl = document.querySelector('.thumbnail-drop__progress--outer'),
        progressOverlayEl = document.querySelector('.thumbnail-drop__progress--overlay'),
        progressDoneEl = document.querySelector('.thumbnail-drop__progress--done');

    xhr.upload.onprogress = function (event) {
        if (event.lengthComputable) {
            var progress = Math.floor((event.loaded / event.total) * 100);
            //console.log('progress = ' + progress);
            if(progressBarEl != null) {
                progressBarEl.style.width = progress + '%';
            }
        }
    };
    xhr.upload.onloadstart = function (event) {
        if(progressBarEl != null && progressOverlayEl != null && progressBarWrapperEl != null) {
            progressBarEl.style.width = '0%';
            progressOverlayEl.style.display = 'block';
            progressBarWrapperEl.style.display = 'block';
        }
    };
    xhr.upload.onloadend = function (event) {
        //console.log('progress = 100% done');
        if(progressBarWrapperEl != null && progressDoneEl != null && progressOverlayEl != null) {
            setTimeout(function () {
                progressBarWrapperEl.style.display = 'none';
                progressDoneEl.style.display = 'block';
            }, 250);
            setTimeout(function () {
                progressOverlayEl.style.display = 'none';
                progressDoneEl.style.display = 'none';
            }, 750);
        }
    };
    xhr.onreadystatechange = function() {
        if(xhr.readyState === XMLHttpRequest.DONE && xhr.status === 200) {
            let user = getState().users.user;
            user.thumbnail = JSON.parse(xhr.responseText);
            dispatch(setUser(user));
            dispatch(postPutUser(callback));
        }
    };
    xhr.send(formData);
};

export const uploadAndImportUsers = (file, callback) => (dispatch, getState) => {
    dispatch(uploadImportUsers(file));

    let xhr = new XMLHttpRequest();
    let formData = new FormData();
    formData.append('file', file);

    xhr.open("POST", PATHS.upload.import(), true);
    xhr.withCredentials = true;
    xhr.setRequestHeader('Accept', 'application/json');

    // Get the thumbnail elements.
    // TODO: This will need to be boilerplated somehow
    let progressBarEl = document.getElementById('thumbnailProgress'),
        progressBarWrapperEl = document.querySelector('.thumbnail-drop__progress--outer'),
        progressOverlayEl = document.querySelector('.thumbnail-drop__progress--overlay'),
        progressDoneEl = document.querySelector('.thumbnail-drop__progress--done');

    xhr.upload.onprogress = function (event) {
        if (event.lengthComputable) {
            var progress = Math.floor((event.loaded / event.total) * 100);
            //console.log('progress = ' + progress);
            if(progressBarEl != null) {
                progressBarEl.style.width = progress + '%';
            }
        }
    };
    xhr.upload.onloadstart = function (event) {
        if(progressBarEl != null && progressOverlayEl != null && progressBarWrapperEl != null) {
            progressBarEl.style.width = '0%';
            progressOverlayEl.style.display = 'block';
            progressBarWrapperEl.style.display = 'block';
        }
    };
    xhr.upload.onloadend = function (event) {
        //console.log('progress = 100% done');
        if(progressBarWrapperEl != null && progressDoneEl != null && progressOverlayEl != null) {
            setTimeout(function () {
                progressBarWrapperEl.style.display = 'none';
                progressDoneEl.style.display = 'block';
            }, 250);
            setTimeout(function () {
                progressOverlayEl.style.display = 'none';
                progressDoneEl.style.display = 'none';
            }, 750);
        }
    };
    xhr.onreadystatechange = function() {
        if(xhr.readyState === XMLHttpRequest.DONE && xhr.status === 200) {
            //console.log('response', typeof xhr.responseText);

            //custom config becease can't have accept application/json header
            let config = {
                method: 'GET',
                credentials: 'include',
                redirect: 'follow',
                mode: 'cors',
                headers: new Headers({
                    'Accept': 'text/plain'
                })
            };

            fetch(PATHS.users.importUsers(JSON.parse(xhr.responseText).id, true), config)
                .then(checkStatus)
                .then((response) => response.text())
                .then((response) => {
                    if(response === 'Success') {
                        fetch(PATHS.users.importUsers(JSON.parse(xhr.responseText).id, false), config)
                            .then(checkStatus)
                            .then((response) => response.text())
                            .then((response) => {
                                if(response === 'Success') {
                                    dispatch(uploadImportUsersSuccess());
                                    if (callback) {
                                        callback(response);
                                    }
                                } else {
                                    dispatch(uploadImportUsersFailure({friendlyMessage: `${response}. There was an error importing your users. Please contact support.`}));
                                }
                            })
                            .catch((error) => {
                                dispatch(uploadImportUsersFailure({friendlyMessage: 'There was an error importing your users. Please contact support.'}));
                            });
                    } else {
                        dispatch(uploadImportUsersFailure({friendlyMessage: `${response}. Please fix your CSV file and re-upload.`}));
                    }
                })
                .catch((error) => {
                    dispatch(uploadImportUsersFailure({friendlyMessage: 'There was an error uploading your file. Please try again.'}));
                });
        }
    };
    xhr.send(formData);
};



// WEBPACK FOOTER //
// ./src/containers/UsersPage/store/users/actions.js